import { Pipe, PipeTransform } from '@angular/core';
import { slugify } from '@frontend/unhideschool/app/helpers/utility-functions';

@Pipe({
    name: 'slugify'
})

export class SlugifyPipe implements PipeTransform {
    transform(str: string): any {
        return slugify(str);
    }
}
